import { ReferralSource } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { ReferralSourceClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export const useReferralSourceListQuery = () => {
  return useQuery({
    queryKey: [queryKeys.referralSources.root, queryKeys.referralSources.list],
    queryFn: async () => {
      const req = ReferralSource.create({ active: 1, withoutLimit: true });
      const res = await ReferralSourceClientService.BatchGet(req);
      return res.results;
    },
    staleTime: 5 * 60 * 1000,
  });
};
